"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _text = require("@mmc/text");
var _commonOptionCard = require("@mmc/common-option-card");
var _commonI18n = require("@mmc/common-i18n");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _reactRedux = require("react-redux");
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _configuratorFabricSelector = _interopRequireDefault(require("../styles/configurator-fabric-selector.css"));
var _configuratorFabricSelector2 = _interopRequireDefault(require("./configurator-fabric-selector.props/configurator-fabric-selector.propTypes"));
var _div, _div2;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } // We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
// import DEFAULT_PROPS from "./configurator-fabric-selector.props/configurator-fabric-selector.defaultProps";
var DEFAULT_PROPS = {};
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps,
  getComponentDataByResourceType = dataUtils.getComponentDataByResourceType,
  handleNestedProp = dataUtils.handleNestedProp,
  isEmptyObject = dataUtils.isEmptyObject,
  appendImageTransforms = dataUtils.appendImageTransforms;
var ConfiguratorFabricSelector = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ConfiguratorFabricSelector, _React$Component);
  ConfiguratorFabricSelector.resourceType = function resourceType() {
    return 'FabricSelector_1_0_0';
  };
  ConfiguratorFabricSelector.isMobile = function isMobile() {
    var desktopWidth = 768;
    return typeof window !== 'undefined' && window.innerWidth < desktopWidth;
  };
  function ConfiguratorFabricSelector(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      filter: null
    };
    _this.renderCards = _this.renderCards.bind((0, _assertThisInitialized2["default"])(_this));
    _this.changeEvent = props.changeEvent || _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  /* eslint-disable */
  var _proto = ConfiguratorFabricSelector.prototype;
  _proto.componentWillMount = function componentWillMount() {
    var _this$props = this.props,
      data = _this$props.data,
      defaultData = _this$props.defaultData;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    var filter = componentData.filter;
  };
  _proto.handleChange = function handleChange(e) {
    var updatedValue = e.target.value;
    this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
      filter: updatedValue
    }));
  }

  // This method just wraps the data utility function to pass in the resourceType and data to check if it exists for this resourceType and if its valid data
  ;
  _proto.selectData = function selectData(data) {
    return getComponentDataByResourceType(data, this.constructor.resourceType());
  };
  _proto.changeEventWithScroll = function changeEventWithScroll(passThrough) {
    if (typeof window !== 'undefined' && this.constructor.isMobile()) {
      if (window.scrollTo !== undefined) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      } else {
        document.body.scrollTop = 0;
      }
    }
    return passThrough;
  };
  _proto.renderCards = function renderCards(_ref, theme, config, addPriceDisclaimer, priceDisclaimerId, disclaimerData) {
    var _this2 = this;
    var filteringOptions = _ref.filteringOptions,
      code = _ref.code;
    if (filteringOptions) {
      var filterValue = this.props.selectedCard || this.state.filter;
      return filteringOptions.map(function (oneOption, i) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: i,
          className: theme['col-xs-6'] + " " + theme['col-lg-4'] + " " + _configuratorFabricSelector["default"].tileWrapper
        }, /*#__PURE__*/_react["default"].createElement(_commonOptionCard.CommonOptionCard, {
          label: '',
          theme: theme,
          id: oneOption.id,
          value: oneOption.code,
          name: 'fabric-selector',
          children: /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("h3", {
            className: theme.inputsAndOptions + " " + _configuratorFabricSelector["default"].cardHeader
          }, oneOption.label), /*#__PURE__*/_react["default"].createElement("p", {
            className: _configuratorFabricSelector["default"].priceLabel + " " + theme.bodyCopy
          }, oneOption.price.value !== undefined && handleNestedProp(oneOption, 'oneOption.price.label'), /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
            format: 'price',
            returnZero: true,
            options: {
              value: handleNestedProp(oneOption, 'oneOption.price.value'),
              currency: handleNestedProp(config, 'config.currencyFormat'),
              locale: handleNestedProp(config, 'config.localeCode')
            },
            addPriceDisclaimer: addPriceDisclaimer,
            priceDisclaimerId: priceDisclaimerId,
            disclaimerData: disclaimerData
          })), /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
            className: _configuratorFabricSelector["default"].colorSample,
            src: appendImageTransforms(handleNestedProp(oneOption, 'oneOption.image.image'), 480),
            width: 480,
            alt: handleNestedProp(oneOption, 'oneOption.image.altText')
          })),
          fullTap: true,
          onChange: _this2.changeEventWithScroll(_this2.changeEvent),
          isSelected: filterValue === oneOption.code ? true : false
        }));
      });
    } else {
      return _div || (_div = /*#__PURE__*/_react["default"].createElement("div", null));
    }
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      data = _this$props2.data,
      theme = _this$props2.theme,
      defaultData = _this$props2.defaultData,
      config = _this$props2.config,
      addPriceDisclaimer = _this$props2.addPriceDisclaimer,
      priceDisclaimerId = _this$props2.priceDisclaimerId,
      disclaimerData = _this$props2.disclaimerData;

    // first we select the data from the larger query coming through
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    var filterObject = isEmptyObject(componentData.filter);
    return /*#__PURE__*/_react["default"].createElement("fieldset", {
      className: _configuratorFabricSelector["default"].fieldset + " " + theme['container-fluid']
    }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
      className: _configuratorFabricSelector["default"].headline + " " + theme.headingThree + " " + theme.marginBottom40,
      tag: "h2",
      text: handleNestedProp(componentData, 'componentData.headingText.title'),
      disclaimerData: disclaimerData
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + _configuratorFabricSelector["default"].container
    }, filterObject ? _div2 || (_div2 = /*#__PURE__*/_react["default"].createElement("div", null)) : this.renderCards(componentData.filter, theme, config, addPriceDisclaimer, priceDisclaimerId, disclaimerData)));
  };
  return ConfiguratorFabricSelector;
}(_react["default"].Component);
ConfiguratorFabricSelector.displayName = 'ConfiguratorFabricSelector';
ConfiguratorFabricSelector.defaultProps = {
  data: DEFAULT_PROPS,
  defaultData: DEFAULT_PROPS,
  theme: {},
  config: {}
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(ConfiguratorFabricSelector);
exports["default"] = _default;